module.exports = __webpack_public_path__ + "img/IMG_9033_L_Black.caadf154.jpg";